import { gql } from "@apollo/client";

export const getLoginMiraklSsoQueryParametersQuery = gql`
  query GetLoginMiraklSsoQueryParameters($marketplaceId: String!) {
    getLoginMiraklSsoQueryParameters(marketplaceId: $marketplaceId) {
      clientId
      tenant
      audience
      state
      url
    }
  }
`;

export const validateLoginMiraklSsoQuery = gql`
  query ValidateLoginMiraklSso($code: String!, $state: String!) {
    validateLoginMiraklSso(code: $code, state: $state) {
      user {
        id
        email
        disabled
        name
        permissions
      }
      authToken
    }
  }
`;